<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
  <div class="container p-0">
    <div class="mControls">
      <div class="input-group mr-auto">
        <h1 class="m-0 text-white align-items-center d-inline-flex">
          {{eventsSignUp?.title}}
        </h1>
      </div>
      <div class="mControls__right">
        <div *ngIf="loggedInUser!==tutorRoleId">
          <div class="input-group">
            <button mat-raised-button color="warn" (click)="deleteEvent(eventsSignUp)">
              <mat-icon>block</mat-icon> Delete link
            </button>
          </div>
        </div>
        <div class="input-group">
          <button mat-raised-button (click)="navigateToEventSignUp()">
            <mat-icon>done</mat-icon> Done
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">General</div>
          <div class="card-body">
            <ul class="list-unstyled form-lr">
              <li>
                <span class="form-lr__left">Description</span>
                <span class="form-lr__right">{{ eventsSignUp?.description }}</span>
              </li>
              <li>
                <span class="form-lr__left">Link</span>
                <span class="form-lr__right"><a [href]="eventsSignUp?.link"
                    target="_blank">{{eventsSignUp?.link}}</a></span>
              </li>
              <li>
                <span class="form-lr__left">Sort Order</span>
                <span class="form-lr__right">{{ eventsSignUp?.sort_order }}</span>
              </li>
              <li>
                <span class="form-lr__left">Icon</span>
                <div class="form-lr__right">
                  <div [ngSwitch]="eventsSignUp?.icon">
                    <span class="icon-24" *ngSwitchCase="'upcoming'">
                      <img src="assets/images/calendar-icon.png" alt="upcoming">
                    </span>
                    <span class="icon-24" *ngSwitchCase='"volunteer"'>
                      <img src="assets/images/volunteer-icon.png" alt="volunteer">
                    </span>
                    <span class="icon-24" *ngSwitchCase='"tutoring"'>
                      <img src="assets/images/tutor-icon.png" alt="tutoring">
                    </span>
                    <span class="icon-24" *ngSwitchCase='"reading"'>
                      <img src="assets/images/book-icon.png" alt="reading">
                    </span>
                    <span class="icon-24" *ngSwitchCase='"miscellaneous"'>
                      <img src="assets/images/miscellaneous-icon.png" alt="miscellaneous">
                    </span>
                    <span class="icon-24" *ngSwitchCase='"speaker"'>
                      <img src="assets/images/speaker-icon.png" alt="speaker">
                    </span>
                    <span class="icon-24" *ngSwitchCase='"list"'>
                      <img src="assets/images/list-icon.png" alt="list">
                    </span>
                    <span class="icon-24" *ngSwitchCase='"training"'>
                      <img src="assets/images/training-icon.png" alt="training">
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>